import { useState, useEffect, useRef } from 'react';
import Card from '@mui/material/Card';
import { shallowEqual, useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import { useNavigate } from 'react-router-dom';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import {ButtonWithSound} from '../Button/Button';
import './Conversation.scss';
import Cover from './cover.jpg'
import Instructions from './instructions.m4a'

const Conversation = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);

    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    const navigate = useNavigate();

    const [practice, setPractice] = useState(false);
    const [main, setMain] = useState(!props.levelUp);
    const [second, setSecond] = useState(false);
    const [levelUp, setLevelUp] = useState(props.levelUp);
    const [displayInfluencerVideo, setDisplayInfluencerVideo] = useState(false);
    const [influencerVideo, setInfluencerVideo] = useState('');

    const scrollRef = useRef();
    const videoPlayer = {
        minWidth: '100%',
        minHeight: '100%',
        position: 'relative',
    };

    const [revealedMessages, setRevealedMessages] = useState([props.selectedConversation[0]]);
    useEffect(() => {
        if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [revealedMessages]);

    useEffect(() => {
        if(props.influencerid){
            GetUserVideo(`influencers/${props.influencerid}/conversation_affirmation.mp4`).then((data) => {
                setInfluencerVideo(data);
            });
        }
    }, []);

    const revealNextMessage = () => {
        if (revealedMessages.length < props.selectedConversation.length) {
            setRevealedMessages([...revealedMessages, props.selectedConversation[revealedMessages.length]]);
        }
        else{
            if(props.levelUp){
                setPractice(false);
                setDisplayInfluencerVideo(true);
            }
            else{
                props.finish();
            }
        }
    };

    return (
        <div className='conversationBody'>
            {displayInfluencerVideo && (
                <div id='influencerVideo'>
                    <video
                    style={videoPlayer}
                    autoPlay
                    onEnded={() => props.finish()}
                    onError={() => props.finish()}
                    playsInline
                    >
                    <source src={influencerVideo} type='video/mp4'></source>
                    </video>
                </div>
            )}
            {main && <div className='mainPage'>
                <audio autoPlay>
                    <source src={Instructions}></source>
                </audio>
                <div className='info'>
                    <img className='cover' alt="cover" src={Cover}/>
                    <div className="avatars">
                        <div className="avatar">
                            <h4 className="character-name">
                                {props.studentName}:
                            </h4>
                            <div className="avatar-inner">
                                <img alt="seleted avatar" src={generateImageUrl(props.selectedStudentCharacter.src)}/>
                            </div>
                        </div>
                        <div className="avatar">
                            <h4 className="character-name">
                                {props.friendName}:
                            </h4>
                            <div className="avatar-inner">
                                <img alt="seleted avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                            </div>
                        </div>
                        </div>
                </div>
                <div className='infoButton'>
                    <ButtonWithSound className='button start' onClick={() => {setMain(false); if(props.scenario){setSecond(true)} else{setPractice(true)}}} label={"START"}/>
                </div>
            </div>}
            {second && <div className='mainPage'>
                <audio autoPlay>
                    <source src={props.scenarioAudio} type="audio/mp3"/>
                </audio>
                <div className='info'>
                    <img className='cover' alt="cover" src={generateImageUrl(props.scenario)}/>
                    <h3>{props.scenarioText}</h3>
                </div>
                <div className='infoButton'>
                    <ButtonWithSound className='button start' onClick={() => {setSecond(false); setPractice(true)}} label={"START"}/>
                </div>
            </div>}
            {levelUp && <div className='mainPage'>
                <audio autoPlay>
                    <source src={generateImageUrl('media/Freeplay/level4/intro/intro_time_to_level_up.mp3')} type="audio/mp3"/>
                </audio>
                <div className='info'>
                    <h3>It’s time to level up! Keep talking to learn more about each other.</h3>
                </div>
                <div className='infoButton'>
                    <ButtonWithSound className='button start' onClick={() => {setLevelUp(false); setPractice(true)}} label={"LEVEL UP"}/>
                </div>
            </div>}
            {practice && <div className="conversation-builder">
                <h1 className="conversation-title">{props.topicName}{props.subTitle ? `: ${props.subTitle}` : ''}</h1>
                <p className="conversation-subtitle">Practice Your Conversation</p>
                <div className="conversation-area" ref={scrollRef}>
                    {revealedMessages.map((message, index) => {
                        // Render 'think' messages as centered black text without speech bubble
                        if (message.sender === 'think') {
                            return (
                                <div key={index} className="think-text-container">
                                    <img 
                                        alt="student avatar" 
                                        src={generateImageUrl(props.selectedStudentCharacter.src)}
                                        className="think-avatar"
                                    />
                                    <p className="think-text">{message.text}</p>
                                </div>
                            );
                        }
                        
                        // Render step messages
                        if (message.sender === 'step') {
                            return (
                                <div
                                    key={index}
                                    className={`${index === 0 ? 'step-container-first' : 'step-container'} message-center`}
                                >
                                    <h1 className="step-text">{message.text}</h1>
                                </div>
                            );
                        }
                        if (message.sender === 'substep') {
                            return (
                                <div key={index} className="substep-text-container">
                                    <div className="substep-avatar-container">
                                        <img 
                                            alt="student avatar" 
                                            src={generateImageUrl(props.selectedStudentCharacter.src)}
                                            className="substep-avatar"
                                        />
                                        <img 
                                            alt="friend avatar" 
                                            src={generateImageUrl(props.selectedFriendCharacter.src)}
                                            className="substep-avatar"
                                        />
                                    </div>
                                    <p className="substep-text">{message.text}</p>
                                </div>
                            );
                        }
                        
                        // Render regular conversation messages
                        return (
                            <div
                                key={index}
                                className={`message-container ${message.sender === 'friend' ? 'message-right' : 'message-left'}`}
                            >
                                <div className={`message-bubble message-${message.sender === 'friend' ? props.selectedFriendCharacter.name : props.selectedStudentCharacter.name}`}>
                                    {message.sender === 'student' && (
                                        <span className="emoji" role="img" aria-label="student">
                                            <img alt="seleted avatar" src={generateImageUrl(props.selectedStudentCharacter.src)}/>
                                        </span>
                                    )}
                                    {message.sender === 'friend' && (
                                        <span className="emoji" role="img" aria-label="friend">
                                            <img alt="seleted avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                                        </span>
                                    )}
                                    <span className="message-text">{message.text}</span>
                                    {/* <button className="sound-button" aria-label="Play sound"></button> */}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='character-container'>
                    <div className='left'>
                        <img alt="seleted avatar" src={generateImageUrl(props.selectedStudentCharacter.full)}/>
                    </div>
                    <div className="middle">
                        <ButtonWithSound
                            button={true}
                            onClick={revealNextMessage}
                            className="next-button"
                            label={revealedMessages.length === props.selectedConversation.length ? "Conversation Complete" : "Next Message"}
                        />
                    </div>
                    <div className='right'>
                        <img alt="seleted avatar" src={generateImageUrl(props.selectedFriendCharacter.full)}/>
                    </div>
            </  div>
            </div>}
            {/* {practice && <div className='character-container'>
                <div className='left'>
                    <img alt="seleted avatar" src={generateImageUrl(props.selectedStudentCharacter.full)}/>
                </div>
                <div className='right'>
                    <img alt="seleted avatar" src={generateImageUrl(props.selectedFriendCharacter.full)}/>
                </div>
            </div>} */}
        </div>
    );
};
export default Conversation;
